import { render, staticRenderFns } from "./HomepageUserButtons.vue?vue&type=template&id=7fbc6b17"
import script from "./HomepageUserButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageUserButtons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports